import React from 'react';
import { getAccessToken } from '../setupAmplify';

function FileDownload({ path, onClick, ...props }) {

    const host = window.__RUNTIME_CONFIG__.API_HOST;
    const downloadAsPdf = async () => {
        // EN-21290: Support onClick callback for pre-download validation
        if (onClick) {
            const shouldProceed = onClick();
            if (shouldProceed === false) {
                return; // User cancelled or validation failed
            }
        }

        let token = await getAccessToken();
        let uri = host + path + `${!path.includes("?") ? "?" : "&"}access_token=${token}`;
        var link = document.createElement("a");
        //link.download = name;
        link.href = uri;
        link.click();
    }

    return (
        <div onClick={downloadAsPdf}>
            {props.children}
        </div>
    )

}

export default FileDownload;